"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExclamationOutline = {
    name: 'exclamation',
    theme: 'outline',
    nameWithTheme: 'exclamation-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'
            },
            children: []
        }
    ]
};
exports.default = ExclamationOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/outline/ExclamationOutline.js
// module id = 1034
// module chunks = 0